import * as React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { NavigateToPath } from "../../../../../../system";
import { customerConstants, ROUTES } from "../../../../../../constants";
import useGetQueryParams from "../../../../../../shared/components/CustomHooks/GetQueryParams";
import AccessGroupGallery from "./Tabs/AccessGroupGallery";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const MyEventsDashboard = () => {
  const { tab } = useParams();
  const history = useHistory();
  const location = useLocation();
  let query = useGetQueryParams();

  const [value, setValue] = React.useState(Number(query.get("tab")));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const updateTabInParams = (tab) => {
    let newLocation =
      location.pathname.slice(0, location.pathname.lastIndexOf("/") + 1) + tab;
    return newLocation;
  };

  React.useEffect(() => {
    setValue(Number(customerConstants.ACCESS_GROUP_GALLERY_TAB_NUMBER));
  }, [tab]);

  return (
    <div className="container-fluid">
      <Box className="row my-5 px-2 px-md-3 customer-dashboard-con customer-event-dashboard ">
        <Box className="col-12 col-lg-3 col-xl-2  bordered-side-bar mx-lg-0 mx-auto">
          <h5 className="ed-sidebar-heading text px-2 text-lg-left text-center">
            my events
          </h5>
          <Tabs
            value={value}
            onChange={handleChange}
            orientation="vertical"
            aria-label="basic event tabs"
            sx={{
              "& .MuiTabs-flexContainer": {
                alignItems: "center",
              },
              "& .MuiTab-root": {
                minHeight: 32,
                padding: "10px 10px",
                margin: "10px 0",

                textAlign: {
                  sm: "center",
                  lg: "start",
                  xs: "center",
                },
                width: "100%",
              },
            }}
          >
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="ACCESS GALLERY"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.ACCESS_GROUP_GALLERY)
                );
              }}
              {...a11yProps(customerConstants.ACCESS_GROUP_GALLERY_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="BACK TO MY EVENT"
              onClick={() => {
                NavigateToPath(history, `${ROUTES.MY_EVENTS_TAB}`);
              }}
            />
          </Tabs>
        </Box>
        <Box className="col-12 col-md-12 col-lg-9 col-xl-10 py-0 tab-pannel custom-min-height">
          <TabPanel
            value={value}
            index={customerConstants.ACCESS_GROUP_GALLERY_TAB_NUMBER}
          >
            <AccessGroupGallery />
          </TabPanel>
        </Box>
      </Box>
    </div>
  );
};

export default MyEventsDashboard;
